interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <nav className="mt-10 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-600 transition-colors cursor-pointer disabled:cursor-not-allowed"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={`min-w-9 h-9 px-2 rounded-md text-sm font-label transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-600 transition-colors cursor-pointer disabled:cursor-not-allowed"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}